export default "__VITE_ASSET__Boh3vppO__"